import GenericForm from "./GenericForm";

export default GenericForm;